/* global ntc, require */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import InputGroup from '../form/input-group';

class Component extends BaseComponent {
    constructor() {
        super();

        this.config = require('../../../config.json');

        this.state = {
            colorName: null,
            colorNames: [],
            colorRGB: null,
        };
    }

    render() {
        return (
            <color-picker>
                <row className='is-wrap has-margin-20-bottom'>
                    <column className='is-2 is-6-mobile'>
                        <InputGroup
                            type='text'
                            maxLength='7'
                            label='Enter a HEX code:'
                            onInput={this.nameColor}
                        />
                    </column>
                    <column className='is-4 is-6-mobile has-padding-30-top'>
                        {this.renderColorSwatch()}
                        {this.renderColorName()}
                    </column>
                    <column className='is-2 is-6-mobile'>
                        <InputGroup
                            type='text'
                            label='Enter a Color Name:'
                            onInput={this.nameToColor}
                        />
                    </column>
                    <column className='is-4 is-6-mobile has-margin-30-top'>
                        {this.renderColors()}
                    </column>
                </row>
            </color-picker>
        );
    }

    nameColor = (e) => {
        this.setState({
            colorName: null,
            colorRGB: null,
        });

        let color = ntc.name(`#${e.target.value.replace('#', '')}`);

        if (!color[1].match(/^Invalid/)) {
            this.setState({
                colorName: color[1].toLowerCase().replace(/ /g, '-'),
                colorRGB: color[0],
            });
        }
    }

    nameToColor = (e) => {
        if (e.target.value != '') {
            const name = new RegExp(e.target.value.replace(/-/g, ' ').toLowerCase());

            const colors = ntc.names.filter(color => {
                return color[1].toLowerCase().match(name);
            });

            this.setState({ colorNames: colors });
        } else {
            this.setState({ colorNames: [] });
        }
    }

    renderColorName = () => {
        if(this.state.colorName) {
            return (
                <span>{`"${this.state.colorName}": "${this.state.colorRGB.toLowerCase()}",`}</span>
            );
        }

        return null;
    }

    renderColorSwatch = () => {
        if (this.state.colorRGB) {
            return (
                <div className='swatch' style={`background-color: ${this.state.colorRGB}`} />
            );
        }

        return null;
    }

    renderColors = () => {
        if (this.state.colorNames.length) {
            return this.state.colorNames.map(color => {
                const hex = color[0];
                const name = this.config['html-colors'].indexOf(color[1].toLowerCase()) !== -1
                    ? `color-${color[1].toLowerCase()}`
                    : color[1];

                return (
                    <div>
                        <div className='swatch' style={`background-color: #${hex.toLowerCase()}`} />
                        <span>{`"${name.toLowerCase().replace(/ /g, '-')}": "#${hex.toLowerCase()}",`}</span>
                    </div>
                );
            });
        }

        return null;
    }
}

export default connect()(Component);